<template>
    <el-form :model="yqInfo" ref="yqInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>周期{{ planType }}</label>
                </div>
                <div class="form-value width-1-5x" @change="checkInfo">
                    <el-radio-group v-model="yqInfo.cronFlag">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="!yqInfo.cronFlag">
                <div class="form-label">
                    <label class="required">{{ planType }}时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="theDateTime" :rules="{validator: checkTheDateTime, trigger: 'blur'}">
                        <el-date-picker v-model="yqInfo.theDateTime" type="datetime" :picker-options="pickerOptions0" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="yqInfo.cronFlag">
                <div class="form-label">
                    <label class="required">{{ planType }}时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="theExprDesc" :rules="{validator: checkNull, trigger: 'blur'}">
                        <span>{{ yqInfo.theExprDesc || '' }}</span>
                        <a class="swb-btn-link" @click="selectCronInfo">选择周期</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="yqInfo.cronFlag">
                <div class="form-label">
                    <label>{{ planType }}截止时间</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ yqInfo.limitEndTime || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>工单截止时间</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="yqFinishTime" :rules="{validator: checkYqFinishTime, trigger: 'change'}">
                        <el-date-picker v-model="yqInfo.yqFinishTime" :picker-options="pickerOptions0" type="datetime" placeholder="请选择" @change="yqFinishTimeChange"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="yqInfo.cronFlag">
                <div class="form-label">
                    <label>要求完成小时</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ yqInfo.yqFinishHours }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>提前预警小时</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="yqFinishAotHr" :rules="{validator: inputYqFinishAotHr, trigger: 'blur'}">
                        <el-input type="number" min="1" class="input-content-right" v-model="yqInfo.yqFinishAotHr"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { openCronEditorDlg } from '../cron/selectDlg'

import comnApi from '../../api/comn'

//
export default {
    name: 'swb-plan-yq-info-for-batch',
    avlScopes: 'retailer',
    desc: '设置要求信息',
    props: {
        planType: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            yqInfo: {
                cronFlag: false,
                theDateTime: null,
                theExprDesc: null,
                limitEndTime: null,
                yqFinishTime: null,
                yqFinishHours: null,
                yqFinishAotHr: null,
            },
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7 || time.format('yyyy') >= new Date('2038-01-19').format('yyyy');
                }
            }
        }
    },
    created: function () {
    },
    methods: {
        // 校验
        checkNull: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('不能为空!'));
            } else {
                callback();
            }
        },
        // 预警小时校验
        inputYqFinishAotHr: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else if(!Utils.isIntStr(value) || value <= 0) {
                callback(new Error('预警小时应为正整数！'));
            } else {
                callback();
            }

        },
        // 工单截止时间设置
        yqFinishTimeChange: function () {
            let yqFinishTime = this.yqInfo.yqFinishTime;
            if(!Utils.isNoB(yqFinishTime)) {
                if(Utils.isNoB(this.yqInfo.theDateTime)) {
                    MsgBox.warning('请先设置' + this.planType + '时间');
                    return false;
                } else {
                    if(Utils.isTrue(this.yqInfo.cronFlag)) {
                        //时间差的毫秒数
                        let times = yqFinishTime.getTime() - this.yqInfo.theDateTime.getTime();
                        let hours = Math.round(times / (3600 * 1000));
                        this.yqInfo.yqFinishHours = Utils.merge(null, hours);
                    }
                }
            }
        },
        checkTheDateTime: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('不能为空!'));
            } else {
                if(new Date() >= value) {
                    callback(new Error(this.planType + '时间需大于当前时间'));
                } else {
                    callback();
                }
            }
        },
        // 选择周期
        selectCronInfo: function () {
            let self = this;
            let yqInfo = this.yqInfo;
            let params = {};
            params.cronJson = yqInfo.theDataJson || {};
            params.cronSecondNeeded = false;
            params.timeLimit = {};
            //
            let dataExType = yqInfo.dataExType;
            let timeLimit = {};
            timeLimit.limitType = dataExType;
            if(dataExType == 2) {   // 限制时间
                timeLimit.limitTimed = yqInfo.limitEndTime;
            } else {
                timeLimit.limitTimed = null;
            }
            params.timeLimit = timeLimit;
            //
            params.fixedYear = false;
            params.fixedYearType = false;
            openCronEditorDlg(params, function (jsonResult) {
                self.getTheDateTime(jsonResult.data, function (theDateTime) {
                    yqInfo.theDateTime = new Date(theDateTime);
                    yqInfo.theDataJson = jsonResult.data;
                    yqInfo.theData = JSON.encode(jsonResult.data);
                    yqInfo.theExprDesc = jsonResult.dataDesc;
                    //
                    let dataEx = jsonResult.dataEx;
                    if(!Utils.isNoB(dataEx)) {
                        yqInfo.dataExType = dataEx.limitType;
                        if(dataEx.limitType == 0) { // 无限制
                            yqInfo.limitEndTime = null;
                        } else if(dataEx.limitType == 2) {  // 限制时间
                            yqInfo.limitEndTime = dataEx.limitTimed || null;
                        }
                    } else {
                        // 不支持-截止时间
                    }
                });
            });
        },
        getTheDateTime: function (theDataJson, callback) {
            let postData = {
                theData: JSON.encode(theDataJson)
            };
            comnApi.getNextExecutionTime(postData, function (result) {
                if(result.type == 'info') {
                    callback(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        checkYqFinishTime(rule, value, callback) {
            if(Utils.isNoB(value)) {
                if(!Utils.isNoB(this.yqInfo.yqFinishAotHr)) {
                    callback(new Error('已设置提前预警小时,请设置工单截止时间'));
                } else {
                    callback();
                }
            } else {
                if(!Utils.isNoB(this.yqInfo.theDateTime) && value < this.yqInfo.theDateTime) {
                    callback(new Error('工单截止时间要晚于首次' + this.planType + '时间:' + this.yqInfo.theDateTime.format("yyyy-MM-dd")));
                } else {
                    callback();
                }
            }
        },
        checkInfo() {
            let yqInfo = this.yqInfo;
            yqInfo.theDateTime = null;
            yqInfo.theExprDesc = null;
            yqInfo.theDataJson = null;
            yqInfo.theData = null;
            this.yqInfo = Utils.merge({}, yqInfo);
        },
        // 保存设备保养/检验计划
        getDlgResult: function () {
            let yqInfo = this.yqInfo;
            //
            let result = {};
            this.$refs['yqInfo'].validate(function (valid) {
                if(valid) {
                    if(!Utils.isNoB(yqInfo.yqFinishAotHr) && Utils.isNoB(yqInfo.yqFinishTime)) {
                        result.message = '请设置工单截止时间';
                    } else {
                        result.type = 'info';
                        result.data = yqInfo;
                    }
                } else {
                    result.message = '请设置相应的要求信息';
                }
            });
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/retailer/PlanYqInfoForBatch.vue